module.exports = __webpack_public_path__ + "img/canbadge_round_100mm.d74a3679.png";